import React, { useEffect, useState } from "react";
import { Breadcrumb, Button, Radio, Select } from "antd";
import { DoubleRightOutlined } from "@ant-design/icons";
import { routes } from "../../../Routes";
import { InputBox } from "../../../components/CustomWidgets/InputBox";
import { useFormik } from "formik";
import SelectBox, {
  MultiSelectBox,
} from "../../../components/CustomWidgets/SelectBox";
import { Image } from "antd";
import {
  InventoryProductRequest,
  InventorySearchonboard,
  fetchGS1,
  getInventoryEditResttriction,
  getUOM,
  updateGsProductRequest,
  uploadImage,
  uploadImageUrl,
} from "../../../API  Functions/InventoryFunctions";
import "../../../styles.css";
import UploadMediaonly from "../../../components/upload-imageonly";
import ProductrequestModal from "../../../modals/ProductrequestModal";
import { productRequestSchema } from "../../../components/validationSchema";
import Navbar from "../../../components/Navbar/Navbar";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../components/Loading";
import { checkPermission } from "../../../Utils/permissionHelper";
import { toast } from "react-toastify";
import { GetRetailerDetails } from "../../../API  Functions/ProfileFunctions";
import axiosInstance from "../../../AxiosInstance";
import { URLS } from "../../../API/API endpoints";
import { getProductGroups } from "../../../API  Functions/productGroupFunctions";

const ProductRequestModal = ({ updateScreen, fetchedProduct, onCancel }) => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const store_id = useSelector(
    (state) => state?.login?.user?.result?.company_id,
  );
  const location = useLocation();
  const userData = useSelector((state) => state?.login?.user?.result);

  const [UOM, setUOM] = useState([]);
  const [isUOMLoaded, setIsUOMLoaded] = useState(false);
  const [popup, setpopup] = useState(false);
  const [isnew, setisnew] = useState(false);
  const [isGS1, setisGS1] = useState(false);
  const [data, setdata] = useState([]);
  const [searchid, setsearchid] = useState("");
  const [base64Image, setBase64Images] = useState("");
  const [isFileValid, setIsFileValid] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [allGroups, setAllGroups] = useState([]);
  const [vatTypes, setVatTypes] = useState([]);
  const [taxId, setTaxId] = useState("");
  const [isEtaEnable, setIsEtaEnable] = useState(null);
  const [costingMethod, setCostingMethod] = useState('');

  const EGS_PREFIX = `EG-${taxId}-`;
  const navigate = useNavigate();

  useEffect(() => {
    if (base64Image && isFileValid === false) {
      setBase64Images("");
      formik.setFieldValue("image_url", "");
    }
  }, [isFileValid, base64Image]);

  useEffect(() => {
    fetchdetails();
    CheckUserAcessForInventory();
  }, []);

  const CheckUserAcessForInventory = async () => {
    try {
      const res = await getInventoryEditResttriction(user_id);
      if (res?.result?.status_code == 200) {
        setIsEtaEnable(res?.result?.is_eta_enabled);
        setCostingMethod(res?.result?.costing_method);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const GetVatTypes = async () => {
    const payload = { retailer_id: store_id, offset: 0, limit: 1000 };
    try {
      const res = await axiosInstance.post(URLS.GET_VAT_TYPES, payload);
      const res1 = res?.data;
      if (res1?.result?.status_code === 200) {
        setVatTypes(res1?.result?.data?.filter(item => item.is_active));
      } else {
        setVatTypes([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
    }
  };

  const fetchdetails = () => {
    GetRetailerDetails(user_id).then((result) => {
      if (result) {
        setTaxId(result?.retailer_details?.tax_card_number ?? null);
      }
    });
  };

  const GetGroups = async () => {
    const payload = {
      lang: i18n.language === "ar" ? "ar_001" : "en_US",
      company_id: store_id,
      user_id: user_id,
      offset: 0,
      limit: 5000,
    };
    try {
      const res1 = await getProductGroups(payload);
      if (res1?.result[0]?.status_code === 200) {
        setAllGroups(res1?.result[0]?.product_groups);
      } else {
        setAllGroups([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
    }
  };

  const get_UOM = async () => {
    const res = await getUOM();
    if (res?.result?.[0].status == "UOM List")
      setUOM(res?.result?.[0]?.uom_list);
    setIsUOMLoaded(true);
  };

  const checkSecondaryBarcode = async (product_id, secondaryBarcode, company_id) => {
    try {
      const body = { product_id, barcode: secondaryBarcode, company_id };
      const res = await axiosInstance.post("/Store/2/CheckBarcode", body);
      return res?.data;
    } catch (error) {
      console.error("Error checking barcode:", error);
      return "error";
    }
  };

  const Productrequest = async (val) => {
    if (!val?.name) return;
    setProcessing(true);

    if (val?.secondaryBarcode?.trim()) {
      const result = await checkSecondaryBarcode(false, val.secondaryBarcode, store_id);
      if (result?.result?.status_code !== 200) {
        toast.error(t(result?.result?.status));
        setProcessing(false);
        return false;
      }
    }

    const costPrice = val?.costprice || 0;
    const salePrice = val?.saleprice || 0;
    const discountedPrice = val?.discounted_price || 0;

    let updatedVal = { ...val };

    if (updatedVal?.barcode?.trim() !== "" && !updatedVal?.is_gs1) {
      const fetchGtinResponse = await axiosInstance.post("/fetch_gs1_data", {
        gtin: updatedVal.barcode.trim(),
      });

      if (fetchGtinResponse.data?.result?.gtin) {
        const resp = fetchGtinResponse.data.result;
        updatedVal.is_gs1 = true;
        if (!updatedVal.custom_name || updatedVal.custom_name.trim() === "") {
          updatedVal.custom_name = updatedVal.name;
        }
        updatedVal.name =
          i18n.language === "ar"
            ? resp.product_description_arabic || resp.product_description_english
            : resp.product_description_english;
      }
    }

    const response = await InventoryProductRequest(user_id, updatedVal, costPrice, salePrice, discountedPrice);

    if (
      response?.result?.[0]?.status_code === 400 &&
      response?.result?.[0]?.status === "Entered short code is already linked with another product."
    ) {
      toast.error(t("Product Short Code Already Exists. Please Use a Different Short Code."));
      setProcessing(false);
      return false;
    }

    if (response?.result?.[0]?.status_code === 200) {
      const productId = response.result[0].product_id;

      if (val?.secondaryBarcode?.trim()) {
        await handleAddSecondaryBarcode(productId, val.secondaryBarcode);
      }

      const uploadedImageUrl = await uploadImage(productId, base64Image);
      if (uploadedImageUrl) {
        formik.setFieldValue("image_url", uploadedImageUrl);
        await uploadImageUrl(productId, uploadedImageUrl);
      }

      const uomName = UOM.find((uom) => uom?.uom_id == updatedVal?.product_uom).uom_name;
      setisnew(true);
      setpopup(true);
      formik.resetForm();
      setBase64Images("");
      setProcessing(false);
      updateScreen(productId, updatedVal, costPrice, salePrice, uomName);
      return true;
    } else {
      if (
        response?.result?.[0]?.status === "The Product already exist with same barcode" &&
        response?.result?.[0]?.product_id
      ) {
        searchResult(updatedVal?.barcode, updatedVal?.quantity, costPrice, salePrice);
      } else {
        toast.error(t(response?.result?.[0]?.status));
        setProcessing(false);
      }
    }

    return false;
  };

  const searchResult = async (value, qty, cp, sp) => {
    let res = await InventorySearchonboard(value);
    if (res.result && Array.isArray(res.result)) {
      const productResponse = res.result[0];
      let updatedVal = {
        name: productResponse?.name,
        custom_name: productResponse?.product_name2,
        barcode: productResponse?.barcode,
        product_code: productResponse?.machine_barcode,
        quantity: qty,
        productShortcut: productResponse?.product_shortcut ?? "",
      };
      if (productResponse.status_code != 400) {
        setProcessing(false);
        updateScreen(productResponse?.prod_id, updatedVal, cp, sp);
      }
    }
  };

  const handleAddSecondaryBarcode = async (id, code) => {
    const payload = {
      company_id: store_id,
      product_id: id,
      barcode_data: [{ id: false, is_delete: false, barcode: code }],
    };
    try {
      const response = await axiosInstance.post(URLS.ADD_SECONDARY_BARCODE, payload);
      if (response?.data?.result?.status_code != 200) {
        toast.error(response?.data?.result?.status);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  useEffect(() => {
    UOM?.length == 0 && get_UOM();
  }, []);

  const formik = useFormik({
    initialValues: {
      name: fetchedProduct?.product_description_english || "",
      custom_name: "",
      barcode: fetchedProduct?.gtin || "",
      product_uom: "",
      costprice: "",
      saleprice: "",
      discounted_price: "",
      quantity: 0,
      image_url: "",
      product_code: "",
      productShortcut: "",
      secondaryBarcode: "",
      groups: [],
      is_gs1: fetchedProduct?.gtin ? true : false,
      isinclusive: null,
      tax_id: null,
      costingMethod: costingMethod,
    },
    enableReinitialize: true,
    validationSchema: productRequestSchema,
  });

  useEffect(() => {
    if (isUOMLoaded && fetchedProduct?.gtin) {
      const uomId = UOM.find((uom) => uom.uom_name === "Units")?.uom_id;
      if (uomId) {
        formik.setFieldValue("product_uom", uomId);
      }
    }
  }, [isUOMLoaded, fetchedProduct, UOM]);

  const validate = (values) => {
    const errors = {};
    if (!values.product_uom) {
      errors.product_uom = "Product UOM is required";
    }

    const isLoose =
      formik.values.product_uom &&
      UOM.find(
        (uom) =>
          (uom.uom_name === "KG" ||
            uom.uom_name === "Kg" ||
            uom.uom_name === "Liter" ||
            uom.uom_name === "Meter") &&
          uom.uom_id === formik.values.product_uom,
      );

    if (isLoose && values.product_code != "" && values.product_code?.length < 7) {
      errors.product_code = "Product Code should have at least 7 digits";
    }

    if (
      values.costprice &&
      values.saleprice &&
      Number(values.costprice) > Number(values.saleprice)
    ) {
      errors.costprice = t("Cost Price cannot be greater than Sale Price");
    }
    if (
      values.discounted_price &&
      values.saleprice &&
      values.discounted_price > values.saleprice
    ) {
      errors.discounted_price = t("Discounted Price cannot be greater than Sale Price");
    }
    return errors;
  };

  const isRTL = i18n.language === "ar";

  return (
    <>
      {processing && <LoadingSpinner />}

      {/* Backdrop */}
      <div className="fixed inset-0 z-30 flex items-center justify-center backdrop-blur-md drop-shadow-sm p-0 sm:p-4">
        <div className="fixed inset-0 bg-black opacity-50 z-40" />

        {/* Modal container */}
        <section
          className="flex flex-col text-lg font-semibold leading-6 bg-white rounded-none sm:rounded-[25px] text-zinc-800 z-50 relative w-full h-full sm:h-auto sm:max-h-[90vh] sm:w-full sm:max-w-5xl xl:max-w-[1300px]"
        >
          {/* Close button */}
          <button
            type="button"
            onClick={onCancel}
            className={`absolute top-4 ${isRTL ? "left-3" : "right-3"} text-zinc-800 bg-transparent z-10`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-8 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          {/* Header */}
          <div className="h-16 bg-[#C9ECF7] rounded-t-none sm:rounded-t-2xl flex items-center flex-shrink-0">
            <p className="ms-10 font-semibold text-xl">{t("Product Request")}</p>
          </div>

          {/* Scrollable body */}
          <div className="flex-1 overflow-y-auto overflow-x-hidden">
            <form onSubmit={formik.handleSubmit}>
              {/* 
                Layout:
                - Mobile: single column, image upload on top, form below
                - Desktop: two columns side by side (form left, image right)
              */}
              <div className="flex flex-col-reverse sm:flex-row bg-white mx-2 border rounded-b-xl">

                {/* ── Left / Bottom: Form fields ── */}
                <div className="flex-1 m-2 p-4">

                  {/* Product Name */}
                  <span className="block leading-[0px]">
                    <div>
                      <InputBox
                        name="name"
                        label={t("product_name")}
                        reqiured
                        placeholder={t("enter_product_name")}
                        onChange={(event) => formik.setFieldValue("name", event.target.value)}
                        onBlur={formik.handleBlur}
                        value={formik.values.name}
                        error={formik.errors.name}
                        readOnly={fetchedProduct?.gtin && fetchedProduct?.product_description_english}
                        touched={formik.touched.name}
                        maxLength={150}
                      />
                    </div>
                  </span>

                  {/* Custom Name + Short Code */}
                  {!userData?.is_sub_store && !userData?.is_warehouse && (
                    <div className="flex flex-col sm:flex-row gap-0 sm:gap-0">
                      <span className="block leading-[0px] w-full sm:w-6/12 sm:me-3">
                        <InputBox
                          name="custom_name"
                          label={t("Custom Product Name")}
                          placeholder={t("Enter Custom Product Name")}
                          onChange={(event) => formik.setFieldValue("custom_name", event.target.value)}
                          onBlur={formik.handleBlur}
                          value={formik.values.custom_name}
                        />
                      </span>
                      <span className="block leading-[0px] w-full sm:w-6/12">
                        <InputBox
                          label={t("Product Short Code")}
                          className={formik.errors.productShortcut ? "border-red" : ""}
                          name="productShortcut"
                          placeholder={t("Enter Product Short Code")}
                          onChange={(e) => formik.setFieldValue("productShortcut", e.target.value)}
                          onBlur={formik.handleBlur}
                          value={formik.values.productShortcut}
                          error={formik.errors.productShortcut}
                          touched={formik.errors.productShortcut}
                          readOnly={userData?.is_sub_store || userData?.is_warehouse}
                          maxLength={10}
                          onKeyPress={(e) => { if (!/[0-9]/.test(e.key)) e.preventDefault(); }}
                        />
                      </span>
                    </div>
                  )}

                  {/* Barcode + Secondary Barcode */}
                  <div className="flex items-end -mt-2">
                    <span
                      className={`block leading-[0px] mt-2 ${
                        !userData?.is_sub_store && !userData?.is_warehouse
                          ? "w-full sm:w-6/12 sm:me-3"
                          : "w-full"
                      }`}
                    >
                      <InputBox
                        type="text"
                        name="barcode"
                        label={t("Barcode")}
                        placeholder={t("Enter Barcode")}
                        maxLength={14}
                        onChange={(event) => {
                          const { value } = event.target;
                          if (/^\d*$/.test(value)) formik.setFieldValue("barcode", value);
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.barcode}
                        error={formik.errors.barcode}
                        touched={formik.touched.barcode}
                        readOnly={!!fetchedProduct?.gtin}
                      />
                    </span>
                    {!userData?.is_sub_store && !userData?.is_warehouse && (
                      <span className="block leading-[0px] w-full sm:w-6/12">
                        <InputBox
                          label={t("Secondary Barcode")}
                          type="number"
                          className={formik.errors.secondaryBarcode ? "border-red" : ""}
                          name="secondaryBarcode"
                          placeholder={t("Enter Secondary Barcode")}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (/^\d{0,18}$/.test(val)) formik.setFieldValue("secondaryBarcode", val);
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.secondaryBarcode}
                          error={formik.errors.secondaryBarcode}
                          touched={formik.errors.secondaryBarcode}
                          maxLength={14}
                        />
                      </span>
                    )}
                  </div>

                  {/* UOM */}
                  <div className="flex flex-row gap-5">
                    <span className="w-full leading-[0px] flex flex-col">
                      <SelectBox
                        name="product_uom"
                        reqiured
                        label={t("product_uom")}
                        defaultValue=""
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.product_uom}
                        options={[
                          { value: "", label: t("select"), disabled: true },
                          ...UOM?.map((item) => ({
                            value: item.uom_id,
                            label: t(item.uom_name),
                          })),
                        ]}
                        error={formik.errors.product_uom}
                        touched={formik.touched.product_uom}
                        disabled={!!fetchedProduct?.gtin}
                      />
                    </span>
                  </div>

                  {/* Weighing Scale Product Code (conditional) */}
                  {formik.values.product_uom &&
                    UOM.find(
                      (uom) =>
                        (uom.uom_name === "KG" ||
                          uom.uom_name === "Kg" ||
                          uom.uom_name === "Liter" ||
                          uom.uom_name === "Meter") &&
                        uom.uom_id === formik.values.product_uom,
                    ) && (
                      <div className="w-full leading-[0px]">
                        <InputBox
                          label={t("Weighing Scale Product Code")}
                          type="number"
                          name="product_code"
                          placeholder={t("Enter Product Code")}
                          onChange={(event) => {
                            const { value } = event.target;
                            if (/^\d{0,7}$/.test(value)) formik.setFieldValue("product_code", value);
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.product_code}
                          error={formik.errors.product_code}
                          touched={formik.touched.product_code}
                        />
                      </div>
                    )}

                  {/* Cost Price + Sale Price */}
                  <div className="flex flex-col sm:flex-row gap-0 sm:gap-0">
                    <span className="leading-[0px] w-full sm:w-6/12 sm:me-3">
                      <InputBox
                        type="text"
                        reqiured={costingMethod === "AVCO"}
                        label={t("cost_price")}
                        name="costprice"
                        placeholder={t("enter_cost_price")}
                        onChange={(event) => {
                          const { value } = event.target;
                          if (
                            value === "" ||
                            (/^(0|[1-9]\d{0,6})(\.\d{0,2})?$/.test(value) &&
                              !/[^\d.]/.test(value) &&
                              !/(--) /.test(value))
                          ) {
                            formik.setFieldValue("costprice", value);
                          }
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.costprice}
                        error={formik.errors.costprice}
                        touched={formik.touched.costprice}
                      />
                    </span>
                    <span className="leading-[0px] w-full sm:w-6/12">
                      <InputBox
                        type="text"
                        reqiured={costingMethod === "AVCO"}
                        label={t("sale_price")}
                        name="saleprice"
                        placeholder={t("enter_sale_price")}
                        onChange={(event) => {
                          const { value } = event.target;
                          if (
                            value === "" ||
                            (/^(0|[1-9]\d{0,6})(\.\d{0,2})?$/.test(value) &&
                              !/[^\d.]/.test(value) &&
                              !/(--) /.test(value))
                          ) {
                            formik.setFieldValue("saleprice", value);
                          }
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.saleprice}
                        error={formik.errors.saleprice}
                        touched={formik.touched.saleprice}
                      />
                    </span>
                  </div>

                  {/* Submit button */}
                  <button
                    type="submit"
                    onClick={async () => {
                      if (!checkPermission("/inventory")) return;
                      const errors = validate(formik.values);
                      formik.setErrors(errors);
                      if (Object.keys(errors).length === 0) {
                        const costPrice = formik.values.costprice || 0;
                        const salePrice = formik.values.saleprice || 0;
                        const check = await Productrequest({
                          ...formik.values,
                          costprice: costPrice,
                          saleprice: salePrice,
                        });
                        if (check) formik.resetForm();
                      }
                    }}
                    disabled={
                      !formik.values.name ||
                      !formik.values.product_uom ||
                      (costingMethod === "AVCO" &&
                        (!formik.values.costprice || Number(formik.values.costprice) <= 0)) ||
                      (formik.values.costprice && !formik.values.saleprice) ||
                      (!formik.values.costprice && formik.values.saleprice) ||
                      Number(formik.values.saleprice) < Number(formik.values.costprice) ||
                      isFileValid === false ||
                      processing
                    }
                    className="w-full sm:w-48 h-10 mt-8 bg-primaryBlue text-white text-sm font-semibold rounded-lg flex items-center justify-center gap-2 disabled:opacity-40"
                  >
                    <span>{t("save_add")}</span>
                  </button>
                </div>

                {/* ── Right / Top: Image upload ── */}
                <div className="m-2 p-4 flex justify-center items-start sm:w-72 sm:flex-shrink-0">
                  <span className="flex flex-col w-full max-w-xs sm:w-64 h-64 sm:h-80 border rounded-xl mt-0 sm:mt-4 justify-center items-center">
                    {formik?.values?.image_url ? (
                      <img
                        src={formik.values.image_url}
                        height={100}
                        width={100}
                        alt="prod"
                        className="object-contain w-full h-full rounded-xl"
                        style={{ maxWidth: "18rem", maxHeight: "13rem" }}
                      />
                    ) : base64Image ? (
                      <img
                        src={base64Image}
                        height={100}
                        width={100}
                        alt="Uploaded"
                        className="object-contain w-full h-full rounded-xl"
                        style={{ maxWidth: "18rem", maxHeight: "13rem" }}
                      />
                    ) : (
                      <svg
                        className="float-left h-10 w-12 text-gray-300"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fillRule="evenodd"
                          d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0021 18v-1.94l-2.69-2.689a1.5 1.5 0 00-2.12 0l-.88.879.97.97a.75.75 0 11-1.06 1.06l-5.16-5.159a1.5 1.5 0 00-2.12 0L3 16.061zm10.125-7.81a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z"
                        />
                      </svg>
                    )}
                    <span className="cursor-pointer mt-2">
                      <UploadMediaonly
                        foldername={"store_image"}
                        onfileAdd={"Productrequest"}
                        setBase64Images={setBase64Images}
                        urlgenerated={(val) => formik.setFieldValue("image_url", val?.url)}
                        imageurl={formik?.values?.image_url ?? ""}
                        setIsFileValid={setIsFileValid}
                      />
                    </span>
                  </span>
                </div>

              </div>
            </form>
          </div>

          {popup && <ProductrequestModal onClose={() => setpopup(false)} isnew={isnew} />}
        </section>
      </div>
    </>
  );
};

export default ProductRequestModal;